module.exports = __webpack_public_path__ + "img/medium-biter-attack.ba206f27.png";